import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { OnboardingStepStatus } from '../onboardingModel';

/** Skip / Ask PRATUS AI / Next row shared by the data steps. */
export function StepFooter({
  status,
  canEdit,
  onSkip,
  onUnskip,
  onAskAi,
  onNext,
  nextLabel = 'Next',
}: {
  status: OnboardingStepStatus;
  canEdit: boolean;
  onSkip: () => void;
  onUnskip: () => void;
  onAskAi: () => void;
  onNext: () => void;
  nextLabel?: string;
}) {
  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:border-t tw:border-border tw:pt-4">
      <Button type="button" variant="outline" onClick={onAskAi}>
        <Sparkles data-icon="inline-start" />
        Ask PRATUS AI
      </Button>
      <div className="tw:ml-auto tw:flex tw:gap-2">
        {status === 'todo' && canEdit ? (
          <Button type="button" variant="ghost" onClick={onSkip}>
            Skip for now
          </Button>
        ) : null}
        {status === 'skipped' && canEdit ? (
          <Button type="button" variant="ghost" onClick={onUnskip}>
            Undo skip
          </Button>
        ) : null}
        <Button type="button" onClick={onNext}>
          {nextLabel}
        </Button>
      </div>
    </div>
  );
}
